import React from 'react';
import Dialog from 'src/components/common/Dialog';
import DialogList from 'src/dialogs';
import * as Constants from 'src/components/common/Constants';
import Button from 'src/components/controls/forms/redesign/FormButton';

interface IFileTooLargeDialogProps {
    s3FileId?: number;
    acknowledge: () => void;
}

const FileTooLargeDialog = (props: IFileTooLargeDialogProps) => {
    return (
        <Dialog title="File Upload Error" dialogName={DialogList.FILE_TOO_LARGE_TO_UPLOAD}>
            <div style={{ textAlign: 'center', fontSize: '2rem' }} className="mb-2">
                File size cannot exceed {Constants.MaxUploadFileSizeBytes} bytes!
            </div>
            <div style={{ textAlign: 'center' }}>
                <Button text="OK" onClick={props.acknowledge} className="mr-2" intent="primary" />
            </div>
        </Dialog>
    );
};

export default FileTooLargeDialog;


// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/FileTooLargeDialog.tsx